import { IStyle, mergeStyles } from "@fluentui/react";
import React, { ReactNode, useEffect, useRef } from "react";

interface ActiveElementRendererProps {
    activeElement: HTMLElement | null;
    children?: ReactNode;
    styles?: { root: IStyle }
}

const activeElementStyles = {
    root: {
        height: "100%",
        position: "relative",
        width: "100%",
    } as IStyle
};

export const ActiveElementRenderer = (props: ActiveElementRendererProps): JSX.Element => {
    const { activeElement, styles, children } = props;
    const divRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (divRef.current && activeElement) {
            divRef.current.appendChild(activeElement);
        }
    }, [activeElement]);

    return (
        <div
            className={mergeStyles(
                activeElementStyles.root,
                styles?.root
            )}
            ref={divRef}
        >
            {children}
        </div>
    );
}
